import { ILabelWithTooltipCellContent } from '@aca-new/app/shared/components/table/shared/components/common-table-cell/shared/label-with-tooltip-cell/shared/interfaces/label-with-tooltip-cell.interface';
import { ICustomizedTableCellComponent } from '@aca-new/app/shared/components/table/shared/components/customized-table-cell/shared/interfaces/customized-table-cell.interface';
import { TrackByUuidDirective } from '@aca-new/app/shared/directives/track-by-uuid.directive';
import { QimaTooltipService } from '@aca-new/app/shared/services/exported-services/qima-tooltip/qima-tooltip.service';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QimaAutoTooltipDirectiveModule, QimaButtonIconModule, QimaIconModule, QimaTooltipDirectiveModule } from '@qima/ngx-qima';

@Component({
  selector: 'app-label-with-tooltip-cell',
  templateUrl: './label-with-tooltip-cell.component.html',
  styleUrls: ['./label-with-tooltip-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, QimaButtonIconModule, QimaIconModule, QimaAutoTooltipDirectiveModule, QimaTooltipDirectiveModule, TranslateModule, TrackByUuidDirective],
})
export class LabelWithTooltipCellComponent implements ICustomizedTableCellComponent {
  public data!: ILabelWithTooltipCellContent;

  public constructor(public readonly qimaTooltip: QimaTooltipService) {}
}
